import { memo } from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

/**
 * Reusable status message component for success/error states
 */
export const StatusMessage = memo(({ type, message, className = '' }) => {
  if (!message) return null;

  const isError = type === 'error';
  const Icon = isError ? XCircle : CheckCircle2;
  const iconColor = isError ? 'text-red-600' : 'text-green-600';
  const textColor = isError ? 'text-red-600' : 'text-green-600';

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Icon className={`w-4 h-4 ${iconColor}`} />
      <p className={`font-['Roboto:Regular',sans-serif] font-normal text-[14px] ${textColor}`}>
        {message}
      </p>
    </div>
  );
});

StatusMessage.displayName = 'StatusMessage';
